import { AccelerationTasks } from '../../../dataAcceleration/resources/AccelerationTasks';
import { ActionHelpers } from '../ActionHelpers';
import { DataAccelerationErrors } from './DataAccelerationErrors';
import { Formatters, Messages } from '../../../codegen/Localize';
import { IAccelerationTaskInfo } from '../../models/IAccelerationTaskInfo';
import { IErrorItem } from '../../models/MultipleItemResult';
import { actionSuccessTranslation, actionErrorTranslation } from '../ContentActionNotification';
import { IResult } from '../../ServerApi/types/IResponse';
import { L10n } from '../../L10n/L10n';
import { openReactConfirmationDialog } from '../../../commonInfra/dialogs/ReactConfirmationDialog';
import { Set } from '../../models/Set';
import { TabDialogWidth } from '../../../commonInfra/dialogs/style/TabDialogWidth';

function showRunDataAccelerationDialog(
  accelerationTasks: Set<IAccelerationTaskInfo>): ng.IPromise<any> {

  let dialogBody: string;
  const taskCount = accelerationTasks.size();
  if (taskCount === 1) {
    const task = accelerationTasks.first();
    dialogBody = Messages.runDataAccelerationTasksForWorkbookRunPrompt({
      WORKBOOK_NAME: L10n.elideIfLong(task.workbook.name)
    });
  } else {
    dialogBody = Messages.runDataAccelerationTasksRunPrompt({
      ITEM_COUNT_LOC: Formatters.formatCount(taskCount)
    });
  }

  const dialogInstance = openReactConfirmationDialog<string[], IResult>({
    title: Messages.runNow(),
    message: dialogBody,
    actionName: Messages.runNowConfirmButton(),
    paramsForAction: accelerationTasks.keys(),
    action: AccelerationTasks.run.bind(AccelerationTasks),
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    ActionHelpers.notifyStandardError(
      accelerationTasks,
      result,
      {
        success: actionSuccessTranslation(Messages.runDataAccelerationTasksRunSuccess),
        error: actionErrorTranslation(Messages.runDataAccelerationTasksRunError),
      },
      (errorItem: IErrorItem<IAccelerationTaskInfo>) => DataAccelerationErrors.errorDetailsForTasks(errorItem)
    );
  });

  return dialogInstance.result;
}

export const RunDataAccelerationTasksAction = {
  showRunDataAccelerationDialog
};

export type RunDataAccelerationTasksAction = typeof RunDataAccelerationTasksAction;
